import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Announcements
const ViewAnnouncementsAndRemindersPage = lazy(
  () => import("@/shared/announcements/pages/announcement-and-reminders-list")
);
const CreateAnnouncementAndRemindersPage = lazy(
  () => import("@/shared/announcements/pages/create-announcement-and-reminders")
);
const AnnouncementDetailsPage = lazy(
  () => import("@/shared/announcements/pages/announcement-details")
);
const EditAnnouncementAndRemindersPage = lazy(
  () => import("@/shared/announcements/pages/create-announcement-and-reminders")
);
const ReminderDetailsPage = lazy(
  () => import("@/shared/announcements/pages/reminder-details")
);

export const announcementsRoutes: RouteObject[] = [
  {
    path: "/admin/announcements",
    element: (
      <RequirePermission resource="announcement">
        <ViewAnnouncementsAndRemindersPage isAdmin={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/announcements/create",
    element: (
      <RequirePermission resource="announcement">
        <CreateAnnouncementAndRemindersPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/announcements/:id",
    element: (
      <RequirePermission resource="announcement">
        <AnnouncementDetailsPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/announcements/edit/:id",
    element: (
      <RequirePermission resource="announcement">
        <EditAnnouncementAndRemindersPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/reminders",
    element: (
      <RequirePermission resource="announcement">
        <ViewAnnouncementsAndRemindersPage isAdmin={true} isReminders={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/reminders/create",
    element: (
      <RequirePermission resource="announcement">
        <CreateAnnouncementAndRemindersPage isReminders={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/reminders/:id",
    element: (
      <RequirePermission resource="announcement">
        <ReminderDetailsPage />
      </RequirePermission>
    ),
  },
];
